/** Canonical marketing site origin (no trailing slash). */
export function getSiteOrigin(): string {
  const u = process.env.REACT_APP_URL || '';
  return u.replace(/\/$/, '');
}

export const APP_STORE_URL = 'https://apps.apple.com/nl/app/gastrobuddy/id1339116265?mt=8';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=en';



// WEBPACK FOOTER //
// ./src/seo/site.ts